var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErlangIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    fill: "#a90533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.018 25.998C2.534 23.366 1.08 19.73 1.085 15.392 1.08 11.556 2.287 8.258 4.36 5.75H0V26h5.018zm22.94.002c1.07-1.146 2.03-2.496 2.897-4.04l-4.82-2.4c-1.693 2.753-4.17 5.286-7.593 5.303-4.983-.017-6.94-4.278-6.93-9.763h18.62c.025-.62.025-.907 0-1.205.122-3.263-.743-6.006-2.316-8.142l-.008.006H32V26h-4.04zM11.812 10.4a4.43 4.43 0 0 1 4.46-4.158c2.3.005 3.98 1.675 4.038 4.158h-8.497z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErlangIcon);
export default __webpack_public_path__ + "static/media/erlang-icon.8e74d9ba91b7267cacbb58cd76161496.svg";
export { ForwardRef as ReactComponent };